import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProfilesService } from '@hcworkspace/analytics-portal/data-sharing';
import { DataSharingService } from '../services/data-sharing.service';
import { IdentityService } from '../services/identity.service';
import { StateService } from '../services/state.service';

@Component({
  selector: 'app-data-sharing-wrapper',
  templateUrl: './data-sharing-wrapper.component.html',
  styleUrls: ['./data-sharing-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DataSharingWrapperComponent implements OnInit {
  public userId: string;

  constructor(
    public stateService: StateService,
    public identityService: IdentityService,
    public profilesService: ProfilesService,
    public dataSharingService: DataSharingService,
    public activatedRoute: ActivatedRoute
  ) {
    this.stateService.setHideHeaderFooterAndNav(true);
  }

  async ngOnInit(): Promise<void> {
    const userRelationsList = await this.identityService.getUserRelationsList();
    const dataSharingPreference = this.profilesService.accepted(userRelationsList);
    this.stateService.setDataSharingAccepted(dataSharingPreference);
  }
}
